import { render, staticRenderFns } from "./ArchiveApplicantMessage.vue?vue&type=template&id=5e89ca2b&"
import script from "./ArchiveApplicantMessage.vue?vue&type=script&lang=js&"
export * from "./ArchiveApplicantMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports